import { useEffect, useState } from 'react'
import { useCreateInviteCodeMutation, useDeleteInviteCodeMutation, useInviteCodesQuery, useInviteTreeQuery } from '../services/useInvitesQuery'


const useMyInvites = () => {
	const [activePage, setActivePage] = useState(1)
	const [allPages, setAllPages] = useState(null)
	const [showCreateModal, setShowCreateModal] = useState(false)

	const [deleteModal, setDeleteModal] = useState({
		open: false,
		id: null,
	})


	const {
		data: inviteCodes,
		isFetching: inviteCodesLoading,
		refetch,
	} = useInviteCodesQuery(activePage)

	const {
		data: inviteTree,
		isFetching: inviteTreeLoading,
		refetch: refetchInviteTree,
	} = useInviteTreeQuery(activePage)


	const { mutate: createInviteCode, isLoading: isCreating } =
		useCreateInviteCodeMutation()

	const { mutate: deleteInviteCode, isLoading: isDeleting } =
		useDeleteInviteCodeMutation({
			onSuccess: () => {
				closeDeleteModal()
				refetch()
			},
		})


	const openDeleteModal = (id) => {
		setDeleteModal({
			open: true,
			id,
		})
	}

	const closeDeleteModal = () => {
		setDeleteModal({
			open: false,
			id: null,
		})
	}

	const finalizeDelete = () => {
		if (!deleteModal.id) return

		deleteInviteCode(deleteModal.id)
	}


	const onPageChange = (page) => {
		setActivePage(page)
	}

	useEffect(() => {
		if (inviteCodes && (allPages !== inviteCodes.meta.total || !allPages)) {
			setAllPages(inviteCodes.meta.total)
		}
	}, [inviteCodes, allPages])

	useEffect(() => {
		refetch()
	}, [activePage, refetch])


	return {
		allPages,
		activePage,
		onPageChange,

		inviteCodes,
		inviteCodesLoading,

		inviteTree,
		inviteTreeLoading,
		refetchInviteTree,

		createInviteCode,
		isCreating,

		deleteModal,
		isDeleting,
		openDeleteModal,
		closeDeleteModal,
		finalizeDelete,

		showCreateModal,
		setShowCreateModal,
	}
}

export default useMyInvites
